import { doorDataProps, windowDataProps } from '@/Interfaces/common';
import { Door } from '@/Engine/Door';
import { doorModelName, windowModelName } from '@/Constants/common';
import { Vector3 } from 'three';
import { Window } from '@/Engine/Window';
import { $ } from '@/Engine/state';
export function addDoor(doorData: doorDataProps) {
    let door = $.doors.find((door) => door.uuid === doorData.uuid);

    if (!door) {
        door = new Door({
            name: doorModelName,
            ...doorData,
        });
        $.doors.push(door);
    }
    $.room.addToWall(door.model, doorData.side);
    // door.computeObb();
    door.position = (new Vector3(...doorData.position));
    return door;
}

export function addWindow(windowData: windowDataProps) {
    let window = $.windows.find((window) => window.uuid === windowData.uuid);
    if (!window) {
        window = new Window({
            name: windowModelName,
            ...windowData,
        });
        $.windows.push(window);
    }

    $.room.addToWall(window.model, windowData.side);
    // window._updateBox();
    // window.computeObb();
    window.position = (new Vector3(...windowData.position));
    window.setDimensions(windowData.width, windowData.height);
    return window;
}